import { Dropdown } from '@/components';
import { useAccountForm } from '@/context/accountFormContext/AccountFormContextProvider';
import { useUser } from '@/context/userContext/UserContextProvider';
import React, { useEffect, useState } from 'react';

const SalesRep = () => {
  const { getSalesReps, salesReps, setSalesReps } = useUser();
  const [selectedSalesRep, setSelectedSalesRep] = useState([]);
  const { accountForm, setAccountForm, errors } = useAccountForm();

  //Get Sales Reps
  useEffect(() => {
    getSalesReps();
    return () => {
      setSalesReps([]);
    };
  }, []);

  // Map sales reps to options

  const salesRepOptions = salesReps?.map((rep) => ({
    label: `${rep.salesRep} ${rep.firstName} ${rep.lastName}`,
    value: rep.id,
    data: rep, // Store the entire sales rep object
  }));

  // Set selected sales rep if only one sales rep is available
  useEffect(() => {
    if (salesReps.length === 1) {
      const singleSalesRep = salesReps[0];
      setSelectedSalesRep([
        {
          label: `${singleSalesRep.salesRep} ${singleSalesRep.firstName} ${singleSalesRep.lastName}`,
          value: singleSalesRep.id,
          data: singleSalesRep,
        },
      ]);
      setAccountForm((prev) => ({
        ...prev,
        salesPerson: singleSalesRep,
      }));
    } else if (accountForm.salesPerson?.id) {
      const existingSalesRep = salesReps.find(
        (rep) => rep.id === accountForm.salesPerson.id,
      );
      if (existingSalesRep) {
        setSelectedSalesRep([
          {
            label: `${existingSalesRep.salesRep} ${existingSalesRep.firstName} ${existingSalesRep.lastName}`,
            value: existingSalesRep.id,
            data: existingSalesRep,
          },
        ]);
      }
    }
    return () => {
      // Cleanup function to reset selected sales rep
      setSelectedSalesRep([]);
    };
  }, [salesReps, accountForm.salesPerson]);

  // Handle sales rep select

  const handleSalesRepSelect = (e) => {
    const selectedValue = e.target.value;
    const selectedSalesRep = salesReps.find(
      (rep) => rep.id === parseInt(selectedValue),
    );

    if (selectedSalesRep) {
      setSelectedSalesRep([
        {
          label: `${selectedSalesRep.salesRep} ${selectedSalesRep.firstName} ${selectedSalesRep.lastName}`,
          value: selectedSalesRep.id,
          data: selectedSalesRep,
        },
      ]);
      setAccountForm((prev) => ({
        ...prev,
        salesPerson: selectedSalesRep,
      }));
    } else {
      // console.log("Sales Rep not found for the selected ID.");
    }
  };

  return (
    <Dropdown
      name="salesPerson"
      label="SALES PERSON"
      options={salesRepOptions}
      onChange={handleSalesRepSelect}
      value={selectedSalesRep.length ? selectedSalesRep[0].value : ''}
      required
      error={accountForm.salesPerson.id == 0 ? errors.salesPerson : ''}
    />
  );
};

export default SalesRep;
